import * as React from 'react';
import { useCurrentBreakPoint } from '@telia-front/helper';
import DesktopTable from './desktop-table';
import MobileTable from './mobile-table';
const TvComparisonContext = React.createContext({
    viewingNecessitiesLabel: null,
    soundLabel: '',
    subTitlesLabel: '',
});
const TvComparison = (props) => {
    const { viewingNecessitiesLabel, soundLabel, subTitlesLabel, showMoreLabel, showLessLabel } = props;
    const currentBreak = useCurrentBreakPoint();
    const isMobile = currentBreak === 'xs' || currentBreak === 'sm';
    const tvComparisonContextValue = {
        viewingNecessitiesLabel: viewingNecessitiesLabel || null,
        soundLabel,
        subTitlesLabel,
        showMoreLabel,
        showLessLabel,
    };
    return (React.createElement(TvComparisonContext.Provider, { value: tvComparisonContextValue }, isMobile ? React.createElement(MobileTable, Object.assign({}, props)) : React.createElement(DesktopTable, Object.assign({}, props))));
};
export { TvComparison as default, TvComparisonContext };
